/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

export default types.model({
	isOpen: types.boolean
}).volatile(()=>({
	triggerNode: types.frozen()
})).views((self) => ({
	getTriggerNode() {
		return self.triggerNode;
	},
	isTooltipOpen() {
		return self.isOpen;
	}
})).actions(self => ({
	closeTooltip() {
		self.isOpen = false;
	},
	openTooltip(triggerNode) {
		self.isOpen = true;
		self.triggerNode = triggerNode;
	}
}));



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipInfoTooltipModel.js